import React, { useState } from "react";
import "./myVoucher.css";
import { useNavigate } from "react-router-dom";
import Cpy1 from "../../../../assets/svg/Cpy1";
import DropArrow from "../../../../assets/svg/DropArrow";

const MyVoucherCard = ({ data = {} }) => {
  const navigate = useNavigate();
      window.scrollTo(0,0)

  const [isHowToUseOpen, setIsHowToUseOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const toggleHowToUse = () => {
    setIsHowToUseOpen(!isHowToUseOpen);
  };
  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      // Show toast
      setToastMessage(`${label} Copied!!`);
      setShowToast(true);
      
      // Hide toast after 2 seconds
      setTimeout(() => {
        setShowToast(false);
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  };

  return (
    <>
      {showToast && (
        <div className="toast-notification">
          <div className="toast-content">
            <span>✓</span> {toastMessage}
          </div>
        </div>
      )}

      <div className="card-border1">
        <div className="card-container1">
          <div className="card-section1">
            <div className="card-img1" style={{ background: data?.outer_color }}>
              <img src={data?.store_image?.thumbnail} alt={data?.p_name} />
            </div>

            <div className="card-info1">
              <div className="card-head1">{data?.p_name}</div>
              <div 
                className="card-desc1" 
                dangerouslySetInnerHTML={{ __html: data.how_to_use_desc }}
              />

              <div className="card-value-cover1">
                <div className="card-value1">
                  <p>Card number</p>
                  <h4>{data?.cards?.[0]?.cardNumber}</h4>
                </div>
                <div 
                  className="card-cpy" 
                  onClick={() => copyToClipboard(data?.cards?.[0]?.cardNumber, "Card Number")}
                >
                  <p>Copy</p>
                  <Cpy1 />
                </div>
              </div>

              <div className="card-value-cover1">
                <div className="card-value1">
                  <p>Pin number</p>
                  <h4>{data?.cards?.[0]?.cardPin}</h4>
                </div>
                <div 
                  className="card-cpy"
                  onClick={() => copyToClipboard(data?.cards?.[0]?.cardPin, "Pin Number")}
                >
                  <p>Copy</p>
                  <Cpy1 />
                </div>
              </div>

              <div 
                className="howtouseHeadCover" 
                onClick={toggleHowToUse}
              >
                <h6 className="howtouseHead">How to use?</h6>
                <div 
                  style={{
                    transform: isHowToUseOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                    transition: 'transform 0.3s ease'
                  }}
                >
                  <DropArrow />
                </div>
              </div>

              <ol 
                className={`howtouseHeadOl ${isHowToUseOpen ? 'open' : ''}`}
                style={{
                  maxHeight: isHowToUseOpen ? '500px' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.3s ease',
                  opacity: isHowToUseOpen ? 1 : 0,
                }}
              >
                {data?.how_to_use_points?.length > 0 && 
                  data.how_to_use_points.map((point, index) => (
                    <li key={index} className="howtouseHeadUl">
                      {point}
                    </li>
                  ))
                }
              </ol>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyVoucherCard;